/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candid_Flaky_Vole_MendInputs */

const fr_candid_flaky_vole_mend = /** @type {(inputs: Candid_Flaky_Vole_MendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

/**

* @param {Candid_Flaky_Vole_MendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const candid_flaky_vole_mend = /** @type {((inputs?: Candid_Flaky_Vole_MendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candid_Flaky_Vole_MendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_candid_flaky_vole_mend(inputs)
});